import { render, staticRenderFns } from "./CommunityActivityManagement.vue?vue&type=template&id=ea8f5e48&scoped=true&"
import script from "./CommunityActivityManagement.vue?vue&type=script&lang=js&"
export * from "./CommunityActivityManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8f5e48",
  null
  
)

export default component.exports